import gql from "graphql-tag";
const invokeCalcModalQuery = gql(` 
query invokeCalcModal($event: AWSJSON!) {
  invokeCalcModal(event: $event) {
    status
  }
}
`)
export default invokeCalcModalQuery;
